import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {RootComponent} from './src/containers/root-component/root.component';
import {RegisterElementService} from './src/services/common/bootstrap/register-element.service';
import {AppComponent} from './app.component';
import {HttpClientModule, HttpClientJsonpModule} from '@angular/common/http';
import {DevelopSandboxComponent} from './src/containers/tools/develop-sandbox/develop-sandbox.component';
import {GetFromUrlPipe} from './src/pipes/get-from-url.pipe';
import {DevelopInViewPortsComponent} from './src/containers/tools/develop-in-view-ports/develop-in-view-ports.component';
import {AsmCustomerSearchComponent} from './src/containers/asm/asm-customer-search/asm-customer-search.component';
import {AsmCustomerSearchFormComponent} from './src/components/asm/search-form/asm-customer-search-form.component';
import {ConfigComponent} from './src/containers/config/config-localization/config.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AsmCustomersSearchResultComponent} from './src/components/asm/search-result/asm-customers-search-result.component';
import {CartSummaryComponent} from './src/containers/cart-summary/cart-summary.component';
import {TpDirective} from './src/directives/tp.directive';
import {SpinnerComponent} from './src/components/spinner/spinner.component';
import {
  ModalInformationAndActionComponent
} from './src/components/modals/modal-information-and-action-component/modal-information-and-action.component';
import {CommonModalComponent} from './src/components/common-modal/common-modal.component';
import {CategorySearchHintsComponent} from './category-search-hints/category-search-hints.component';
import {MiniSearchBoxResultComponent} from './src/components/mini-search-box-result/mini-search-box-result.component';
import {MiniSearchBoxComponent} from './src/containers/mini-search-box/mini-search-box.component';
import {FormWithInputComponent} from './src/components/form-with-input/form-with-input.component';
import {setAppInjector} from './src/utils/appInjector/setAppInjector';
import {PageMessageComponent} from './src/components/page-message/page-message.component';
import {LensesConfiguratorComponent} from './src/components/lenses-configurator/lenses-configurator.component';
import {ListOfCitiesComponent} from './src/containers/list-of-cities/list-of-cities.component';
import {ListOfSalonsComponent} from './src/containers/list-of-salons/list-of-salons.component';
import {MapHolderComponent} from './src/containers/map-holder/map-holder.component';
import {InputComponent} from './src/components/input/input.component';
import {ButtonComponent} from './src/components/buttons/button.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {posFilterPipe} from "./src/pipes/pos.filter.pipe";
import {cityFilterPipe} from "./src/pipes/product-availability-city-pos.filter.pipe";
import {LOCALE_ID} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { NgSelectModule } from '@ng-select/ng-select';
import {ModalStatementComponent } from './src/components/modals/modal-statement/modal-statement.component';
import {ProductAvailabilityComponent} from './src/components/product-availability/product-availability.component';
import {CartDeliveryPaymentComponent} from './src/containers/cart-delivery-payment/cart-delivery-payment.component';
import {CartPosesComponent} from './src/components/cart-poses/cart-poses.component';
import {ScrollToDirective} from "./src/directives/scrollto.directive";
import {CartInpostComponent} from "./src/components/cart-inpost/cart-inpost.component";
import {CartPocztaPolskaComponent } from "./src/components/cart-poczta-polska/cart-poczta-polska.component";
import {CartDpdComponent} from "./src/components/cart-dpd/cart-dpd.component";
import {CounterPipe } from './src/pipes/counter.pipe';
import {ModalAsmExpireComponent}  from "./src/components/modals/modal-asm-expire/modal-asm-expire.component";
import {FramesSizeFilterComponent} from "./src/components/frames-size-filter/frames-size-filter.component";
import {DigitOnlyDirective} from "./src/directives/digit-only.directive";
import {SubscriptionsHistoryComponent} from "./src/components/subscriptions-history/subscriptions-history.component";
import {ModalConfirmComponent} from "./src/components/modals/modal-confirm/modal-confirm.component";
import {ModalCancelOrderComponent} from "./src/components/modals/modal-cancel-order/modal-cancel-order.component";
import {ListingFacetsComponent} from "./src/containers/listing-facets/listing-facets.component";
import {FacetComponent} from "./src/components/facet/facet.component";
import {FacetSearchBarComponent} from "./src/components/facet-search-bar/facet-search-bar.component";
import {TitlePipe} from "./src/pipes/title.pipe";
import {AsmOrderReassignmentComponent} from "./src/containers/asm/asm-order-reassignment/asm-order-reassignment.component";
import {AsmCustomersForOrderComponent} from "./src/components/asm/asm-customers-for-order/asm-customers-for-order.component";
import {DynamicScriptDirective} from "./src/directives/dynamic-script.directive";
import {GoogleMapsModule} from '@angular/google-maps';
import {ProductDetailsPageModule} from "./src/pages/product-details-page/product-details-page.module";
import { ProductDetailsPageComponent } from './src/containers/product-details-page/product-details-page.component';
import {SharedModule} from "./src/shared/shared.module";
import {CartInstallmentComponent} from './src/components/cart-installment/cart-installment.component';
import {ModalCancelSubscriptionComponent} from "./src/components/modals/modal-cancel-subscription/modal-cancel-subscription.component";

registerLocaleData(localePl, 'pl');

const MODALS = [
  ModalInformationAndActionComponent,
  ModalStatementComponent,
  ModalAsmExpireComponent,
  ModalConfirmComponent,
  ModalCancelOrderComponent,
  ModalCancelSubscriptionComponent
];

const ELEMENTS_LIST = [
  ...MODALS,
  DevelopSandboxComponent,
  AsmCustomerSearchComponent,
  ConfigComponent,
  SpinnerComponent,
  CommonModalComponent,
  MiniSearchBoxComponent,
  PageMessageComponent,
  LensesConfiguratorComponent,
  ButtonComponent,
  ListOfCitiesComponent,
  ListOfSalonsComponent,
  MapHolderComponent,
  InputComponent,
  ProductAvailabilityComponent,
  CartDeliveryPaymentComponent,
  CartPosesComponent,
  CartSummaryComponent,
  CartInpostComponent,
  CartPocztaPolskaComponent,
  CartDpdComponent,
  FramesSizeFilterComponent,
  SubscriptionsHistoryComponent,
  ListingFacetsComponent,
  FacetComponent,
  FacetSearchBarComponent,
  AsmOrderReassignmentComponent,
  AsmCustomersForOrderComponent,
  ProductDetailsPageComponent,
  CartInstallmentComponent
];

@NgModule({
  declarations: [
    AppComponent,
    RootComponent,
    GetFromUrlPipe,
    DevelopInViewPortsComponent,
    AsmCustomersSearchResultComponent,
    AsmCustomerSearchFormComponent,
    ...ELEMENTS_LIST,
    TpDirective,
    CategorySearchHintsComponent,
    MiniSearchBoxResultComponent,
    FormWithInputComponent,
    posFilterPipe,
    cityFilterPipe,
    ScrollToDirective,
    CounterPipe,
    DigitOnlyDirective,
    TitlePipe,
    DynamicScriptDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    NgSelectModule,
    GoogleMapsModule,
    ProductDetailsPageModule,
    SharedModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'pl'}
  ],
  bootstrap: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule {
  constructor(
    private registerElementService: RegisterElementService,
    private injector: Injector
  ) {
    setAppInjector(injector);
  }

  ngDoBootstrap() {
    this.registerElementService.registerElements();
  }
}
